if (!customElements.get('lera-pi-financing')) {
  customElements.define(
    'lera-pi-financing',
    class LeraPiFinancing extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.installments = Math.max(1, parseInt(this.dataset.installments, 10) || 6);
        this.priceDivisor = Math.max(1, parseInt(this.dataset.priceDivisor, 10) || 100);
        this.amountEl = this.querySelector('[data-lera-financing-amount]');
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        this.updateFromPrice(parseInt(this.dataset.variantPrice, 10) || 0);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event?.data || event.data.sectionId !== this.sectionId) return;
            const variant = event.data.variant;
            if (!variant || typeof variant.price !== 'number') return;
            this.updateFromPrice(variant.price);
          });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      calculateInstallment(priceRaw) {
        if (!priceRaw || priceRaw <= 0) return 0;
        const sellingPrice = priceRaw / this.priceDivisor;
        return Math.round(sellingPrice / this.installments);
      }

      formatAmount(amount) {
        if (!amount) return '';
        const rounded = Math.round(amount);
        return `$${rounded.toLocaleString('es-CL')}`;
      }

      updateFromPrice(priceRaw) {
        if (!this.amountEl) return;
        const installment = this.calculateInstallment(priceRaw);
        this.amountEl.textContent = this.formatAmount(installment);
        this.dataset.variantPrice = String(priceRaw);
      }
    }
  );
}
